import type { IconDefinition } from '../index.tsx';

export const iconArrowDown: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowDown',
  icon: [16, 16, [], '', 'M10 8L14 8V10L8 16L2 10V8H6V0L10 4.76995e-08V8Z'],
};
